export default {
  // 地址列表
  async getAddressListAsync(context, payload) {
    if (context.state.addressList.status) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/u/buyer_address_lists.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_ADDRESS_LIST', res.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 添加地址
  async addAddressAsync(context, payload) {
    try {
      const res = await this.$http.post('/u/add_save_buyer_address.html', payload);
      if (res.data.status === 1) {
        context.commit('RESET_ADDRESS_LIST');
        await context.dispatch('getAddressListAsync', { buyerId: context.rootState.user.sellerId });
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 编辑地址
  async editAddressAsync(context, payload) {
    try {
      const res = await this.$http.post('/u/add_save_buyer_address.html', payload);
      if (res.data.status === 1) {
        context.commit('RESET_ADDRESS_LIST');
        await context.dispatch('getAddressListAsync', { buyerId: context.rootState.user.sellerId });
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 删除地址
  async deleteAddressAsync(context, payload) {
    try {
      const res = await this.$http.post('/u/del_address.html', payload);
      if (res.data.status === 1) {
        context.commit('RESET_ADDRESS_LIST');
        await context.dispatch('getAddressListAsync', { buyerId: context.rootState.user.sellerId });
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 发货单列表
  async getShippingListAsync(context, payload) {
    try {
      const res = await this.$http.post('/sd/lists.html', payload);
      if (res.data.status === 1) {
        return Promise.resolve(res.data.data);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 收藏列表
  async getFavoriteListAsync(context, payload) {
    if (context.state.favoriteList.status && +context.state.favoriteList.currentPage === payload.p) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/gc/getGoodsCollect.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_FAVORITE_LIST', res.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 订单列表
  async getOrderListAsync(context, payload) {
    if (context.state.orderList[payload.target].status && payload.p === +context.state.orderList[payload.target].data.p) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/sor/lists.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_ORDER_LIST', {
          data: res.data,
          target: payload.target,
        });
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 订单详情
  async getOrderDetailAsync(context, payload) {
    try {
      const res = await this.$http.post('/sor/orderDetail.html', payload);
      if (res.data.status === 1) {
        return Promise.resolve(res.data.data);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 取消订单
  async cancelOrderAsync(context, payload) {
    try {
      const res = await this.$http.post('/sor/orderByCancel.html', payload);
      if (res.data.status === 1) {
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        context.commit('RESET_ORDER_LIST', 'all');
        context.commit('RESET_ORDER_LIST', 'unpayed');
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // // 订单详情
  // async getOrderOrderAsync(context, payload) {
  //   try {
  //     const res = await this.$http.post('/sor/orderDetail.html', payload);
  //     if (res.data.status === 1) {
  //       return Promise.resolve(res.data.data);
  //     }
  //     throw new Error(res.data.info);
  //   } catch (error) {
  //     context.commit(
  //       'TOGGLE_SNACKBAR',
  //       {
  //         type: 'error',
  //         text: error.message,
  //       },
  //       { root: true },
  //     );
  //     return Promise.reject(error);
  //   }
  // },
  // 用户信息
  async setAccountAsync(context, payload) {
    try {
      const res = await this.$http.post('/su/save_sale_user.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_USER', { data: payload.params }, { root: true });
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 用户密码
  async setPasswordAsync(context, payload) {
    try {
      const res = await this.$http.post('/adm/do_admin.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_USER', { data: payload.params }, { root: true });
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
};
